import { Injectable } from '@angular/core';

import { Actions } from '@ngrx/effects';
import { map } from 'rxjs/operators';

import { createEffectFactory } from '@recruitee/ngrx';

import { InterviewTemplatesHttpService } from '../interview-templates-http.service';
import { actions } from './interview-templates-categories.store';

@Injectable()
export class InterviewTemplatesCategoriesEffects {
  public effect = createEffectFactory(actions, this.actions$);

  public fetchCollection = this.effect(actions.fetchCollection, ({ payload: { scope } }) =>
    this.interviewTemplatesHttpService
      .fetchCategories(scope)
      .pipe(map(data => ({ data: data.map(name => ({ name })), scope }))),
  );

  constructor(
    private actions$: Actions,
    private interviewTemplatesHttpService: InterviewTemplatesHttpService,
  ) {}
}
